import type { Entity } from '@models/Entity'

import { apiClient } from '../../../gateways/api'
import type { AssignedBijlage } from '../types/AssignedBijlage'

export { completeAssignedBijlageForEntity }

const completeAssignedBijlageForEntity = async ({
  entity: { id: entityId, type },
  id,
  assignedTo,
}: {
  entity: Entity
  id: string
  assignedTo?: string
}): Promise<AssignedBijlage> => {
  const { data } = await apiClient({
    url: `/rest/${type}/${entityId}/bijlageassigned/${id}`,
    method: 'PATCH',
    data: assignedTo ? { status: 'review', assignedTo } : { status: 'done' },
  })

  return data
}
